import { BaseClient } from '../client';

interface userNotifications {
	idUsuario: number;
	tagReceberEmail: string;
	tagReceberPush: string;
}

export const postUserNotifications = async (body: userNotifications) => {
	if (process.env.NODE_ENV === 'development') {
		return 'Sucesso';
	}

	try {
		const response = await BaseClient.post<string>(`/Usuarios/UpdateReceberEmailPush`, body).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		throw error;
	}
};
